import * as types from '../constants/actionTypes';
import * as resultTypes from '../constants/resultTypes';
import {checkDigit, displayResult, errorResultType} from '../utils/imeiSearchUtils';
import eirSearchApi from '../api/eirSearchApi';

export function searchImeiAction(imei, display, result) {
  return {type: types.SEARCH_IMEI,
    imei: imei,
    displayResult: display,
    result: result
  };
}

// 15 (14 + 1 check digit) digits then do the check digit validation. Remove the last check digit and send the first 14 digits to the backend
// 16 digits (14 + 2 software version). Skip any checks just send the entire 16 digits to the backend
export function searchImei(imei) {
  return function (dispatch) {

    imei = imei.trim();
    let display = displayResult(imei) || (imei.length === 16);

    if (!display) {
      dispatch(searchImeiAction(imei, display, ''));
    } else {
      if(imei.length === 16){
        return eirSearchApi.search(imei)
          .then(value => { dispatch(searchImeiAction(imei, display, value)) })
          .catch(error => { dispatch(searchImeiAction(imei, display, errorResultType(error))) });
      }

      if (!checkDigit(imei)) {
        dispatch(searchImeiAction(imei, display, resultTypes.NOT_FIND));
      } else {
        let rawImei = imei.slice(0, -1);
        return eirSearchApi.search(rawImei)
          .then(value => { dispatch(searchImeiAction(imei, display, value)) })
          .catch(error => { dispatch(searchImeiAction(imei, display, errorResultType(error))) });
      }
    }

  }
}
